module.exports = __webpack_public_path__ + "img/xmsb11.c85d897e.png";